// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202512230803/js/" + chunkId + "." + {"44":"4f6428aa","225":"2ff0b57b","481":"7ee9c6ac","486":"05ae3580","770":"b3d13dff"}[chunkId] + ".0.9067496097100332.chunk.js";
};